var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightSign = function SvgRightSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#414042",
    d: "m2.063 18 9-9-9-9-2 2 7 7-7 7z"
  })));
};
export { SvgRightSign as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxMiAxOCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KPGcgaWQ9IkNhbnZhcyIgZmlsbD0ibm9uZSI+CjxwYXRoIGlkPSJWZWN0b3IgMi4xIiBkPSJNIDkgMEwgMCA5TCA5IDE4TCAxMSAxNkwgNCA5TCAxMSAyTCA5IDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMS4wNjI1IDE4KSBzY2FsZSgtMSkiIGZpbGw9IiM0MTQwNDIiLz4KPC9nPgo8L3N2Zz4K";